import {
  Periods,
  buildReportQuery,
  mergeReportData,
  mergeCampaignReportData,
  convertPeriodToRange,
} from '@/models/StandardReport'
import dayjs from 'dayjs'

export default {
  range(state) {
    const { period, calendarRange } = state
    return period === Periods.CALENDAR
      ? calendarRange
      : convertPeriodToRange(state.period)
  },
  /**
   * 現在の設定値に従い全体orデイリーレポート取得用のクエリを生成する関数を返す。
   */
  buildReportQuery(state) {
    return buildReportQuery(state)
  },
  reportData(state, getters) {
    // 案件データとレポートデータをマージする
    const { insertionOrders, reportData } = state
    const { range } = getters
    return mergeReportData({ reportData, insertionOrders, period: range })
  },
  dailyReportData(state) {
    return state.dailyReportData.data
  },
  genCampaignReportKey() {
    return insertionOrderId => `io-${insertionOrderId}`
  },
  getCampaignReportData(state, getters) {
    const { genCampaignReportKey } = getters

    return insertionOrderId => {
      const key = genCampaignReportKey(insertionOrderId)
      const reportData = state.campaignReportData[key]

      return mergeCampaignReportData(reportData)
    }
  },
  getDeliveryGroupReportData(state, getters) {
    const { genDeliveryGroupReportKey } = getters
    return campaignId => {
      const key = genDeliveryGroupReportKey(campaignId)
      return state.deliveryGroupReportData[key].data
    }
  },
  genDeliveryGroupReportKey() {
    return campaignId => `cp-${campaignId}`
  },
  getSelectedBillingPeriodIds(state) {
    if (!state.selectedBillingPeriodIds) return []
    return state.selectedBillingPeriodIds
  },
  getCampaignBudgets(state) {
    return (campaignId, range) => {
      const { startDate, endDate } = range
      const campaignList = Object.values(state.campaigns).flat()
      const campaign = campaignList.find(campaign => {
        return campaign.id === campaignId
      })
      if (startDate || endDate) {
        return campaign.campaignBudgets.filter(cb => {
          const cbStartTime = dayjs(cb.startTime)
          const cbEndTime = dayjs(cb.endTime)
          return (
            (cbStartTime.isBefore(startDate) && cbEndTime.isAfter(startDate)) ||
            (cbStartTime.isBefore(endDate) && cbEndTime.isAfter(endDate))
          )
        })
      }
      return campaign.campaignBudgets
    }
  },
  getSelectedCampaignBudgetIds(state) {
    return campaignId => {
      const campaignBudgetIds = state.selectedCampaignBudgetIds[campaignId]
      if (campaignBudgetIds === undefined) return []
      return campaignBudgetIds
    }
  },
}
